import React from "react";
import { Col } from "react-bootstrap";
import { Button as ButtonAntd, Switch } from "antd";

export default function ActionButtons({
  mode,
  disabled,
  setDisabled,
  selectedUser,
  handleSaveRoles,
  handleSavePrivileges,
  submitting,
}) {
  return (
    <Col className="col-12 mb-3 mt-2 d-flex align-items-center justify-content-between">
      <Switch
        checked={!disabled}
        checkedChildren="Assign"
        unCheckedChildren="Enable"
        onClick={() => setDisabled((prev) => !prev)}
        disabled={!selectedUser}
      />
      {!disabled && (
        <div className="d-flex align-items-end justify-content-between">
          <div>
            {submitting ? (
              <ButtonAntd
                type="primary"
                loading
                iconPlacement="end"
                size="sm"
                className="ms-2 bg-success"
                style={{ fontFamily: "Inter" }}
              >
                Saving
              </ButtonAntd>
            ) : (
              <ButtonAntd
                variant="success"
                size="sm"
                onClick={
                  mode === "roles" ? handleSaveRoles : handleSavePrivileges
                }
                className="text-nowrap text-xs ms-2 bg-success text-white"
              >
                Save
              </ButtonAntd>
            )}
          </div>
        </div>
      )}
    </Col>
  );
}
